import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './EditContactInfoButtons.css'; // Archivo CSS para los estilos

// eslint-disable-next-line no-unused-vars
const EditContactInfoButtons = (props, context) => {
  const onCancelClick = () => {
    props.onCancel();
  };

  const onSaveClick = () => {
    props.onSave();
  };

  return (
        <div className="botones-container">
          <button className="boton-cancelar" onClick={() => onCancelClick()}>
            {context.t('Cancel')}
          </button>
          <button className="boton-guardar" onClick={() => onSaveClick()}>
            {context.t('Save')}
          </button>
        </div>
  );
};

EditContactInfoButtons.propTypes = {
  name: PropTypes.string.isRequired,
};

EditContactInfoButtons.contextTypes = {
  t: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default connect((state) => ({
  multipleRoomSelection: state.booking.multipleRoomSelection,
  cart: state.cart,
  lang: state.i18nState.lang,
  hotel: state.booking.hotel,
}))(EditContactInfoButtons);
